import { render, staticRenderFns } from "./PaginationLimit.vue?vue&type=template&id=1f624358&lang=pug"
import script from "./PaginationLimit.vue?vue&type=script&lang=js"
export * from "./PaginationLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports